var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-field',{attrs:{"label":_vm.$t('profile.change.header') +
    ' (' +
    _vm.$t('profile.change.created') +
    ' ' +
    _vm.date(_vm.user.modified.created) +
    ')'}},[_c('p',[_vm._v(_vm._s(_vm.$t("profile.change.description")))]),_c('button',{staticClass:"vca-button",on:{"click":function($event){return _vm.navigateToLogin()}}},[_vm._v(" "+_vm._s(_vm.$t("profile.change.manage"))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t("profile.edit.profile.delete.description"))+" ")]),_c('br'),_c('div',{staticClass:"vca-center"},[_c('vca-cancel-button',{attrs:{"placeholder":_vm.$t('button.delete')},on:{"click":function($event){return _vm.deleteProfile()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }